"use client";

import { useState, useEffect, useRef } from "react";
import Link from "next/link";
import AppImage from "@/components/ui/AppImage";
import Icon from "@/components/ui/AppIcon";

const categories = ["全部", "清潔用品", "個人護理", "廚房用品", "辦公用品", "嬰幼兒用品"];

const allProducts = [
{
  id: "laundry-detergent",
  name: "濃縮洗衣液",
  nameEn: "Concentrated Laundry Detergent",
  category: "清潔用品",
  price: "HK$ 38",
  unit: "1L / 瓶",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1f8c751d2-1767878728973.png",
  alt: "濃縮洗衣液，藍色瓶裝，1升裝，適合家庭使用",
  tags: ["暢銷", "批發優惠"],
  inStock: true
},
{
  id: "dish-soap",
  name: "天然洗碗液",
  nameEn: "Natural Dish Soap",
  category: "清潔用品",
  price: "HK$ 28",
  unit: "500ml / 瓶",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_181bb64ba-1765097405377.png",
  alt: "天然洗碗液，綠色環保包裝，500毫升裝",
  tags: ["天然配方"],
  inStock: true
},
{
  id: "floor-cleaner",
  name: "多效地板清潔劑",
  nameEn: "Multi-Effect Floor Cleaner",
  category: "清潔用品",
  price: "HK$ 42",
  unit: "2L / 瓶",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_16d2a4067-1764701910722.png",
  alt: "多效地板清潔劑，2升大容量，適合各類地板",
  tags: ["大容量"],
  inStock: true
},
{
  id: "shampoo",
  name: "滋養洗髮水",
  nameEn: "Nourishing Shampoo",
  category: "個人護理",
  price: "HK$ 52",
  unit: "400ml / 瓶",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1d75b9cbd-1765173220232.png",
  alt: "滋養洗髮水，白色優雅瓶裝，400毫升裝",
  tags: ["新品"],
  inStock: true
},
{
  id: "body-wash",
  name: "保濕沐浴露",
  nameEn: "Moisturizing Body Wash",
  category: "個人護理",
  price: "HK$ 48",
  unit: "500ml / 瓶",
  img: "https://images.unsplash.com/photo-1724682620336-413a1fdc891d",
  alt: "保濕沐浴露，粉色瓶裝，滋潤配方",
  tags: ["保濕"],
  inStock: true
},
{
  id: "toothpaste",
  name: "防蛀牙膏",
  nameEn: "Anti-Cavity Toothpaste",
  category: "個人護理",
  price: "HK$ 22",
  unit: "120g / 支",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_14757d2ed-1766183888754.png",
  alt: "防蛀牙膏，白色包裝，120克裝，薄荷清涼口味",
  tags: ["熱銷"],
  inStock: true
},
{
  id: "kitchen-cleaner",
  name: "廚房多功能清潔劑",
  nameEn: "Kitchen Multi-Purpose Cleaner",
  category: "廚房用品",
  price: "HK$ 45",
  unit: "750ml / 瓶",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1c4a0cc3e-1765097405769.png",
  alt: "廚房多功能清潔劑噴霧瓶，750毫升裝",
  tags: ["熱銷"],
  inStock: true
},
{
  id: "sponge-scrubber",
  name: "百潔布套裝",
  nameEn: "Sponge Scrubber Set",
  category: "廚房用品",
  price: "HK$ 18",
  unit: "5件 / 套",
  img: "https://images.unsplash.com/photo-1678411879087-b4c309d984fc",
  alt: "百潔布套裝，5件裝，多色海綿清潔布",
  tags: ["超值套裝"],
  inStock: true
},
{
  id: "trash-bags",
  name: "環保垃圾袋",
  nameEn: "Eco-Friendly Trash Bags",
  category: "廚房用品",
  price: "HK$ 25",
  unit: "50個 / 卷",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_172f01262-1769512907581.png",
  alt: "環保垃圾袋，50個一卷，可降解材料",
  tags: ["環保"],
  inStock: true
},
{
  id: "office-tissue",
  name: "辦公室面紙",
  nameEn: "Office Facial Tissue",
  category: "辦公用品",
  price: "HK$ 35",
  unit: "200抽 × 3盒",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1c49f948b-1765097404987.png",
  alt: "辦公室面紙，3盒裝，200抽每盒，純白柔軟",
  tags: ["批量優惠"],
  inStock: true
},
{
  id: "hand-sanitizer",
  name: "免洗消毒洗手液",
  nameEn: "Hand Sanitizer Gel",
  category: "辦公用品",
  price: "HK$ 32",
  unit: "500ml / 瓶",
  img: "https://images.unsplash.com/photo-1716003796312-3d047801272b",
  alt: "免洗消毒洗手液，500毫升泵裝，75%酒精",
  tags: ["抗菌"],
  inStock: true
},
{
  id: "baby-shampoo",
  name: "嬰兒洗髮沐浴露",
  nameEn: "Baby Shampoo & Body Wash",
  category: "嬰幼兒用品",
  price: "HK$ 65",
  unit: "400ml / 瓶",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1b73d02-1769340081409.png",
  alt: "嬰兒洗髮沐浴露，400毫升，溫和無淚配方",
  tags: ["溫和配方", "嬰兒專用"],
  inStock: false
}];


export default function ProductsInteractive() {
  const [activeCategory, setActiveCategory] = useState("全部");
  const [searchQuery, setSearchQuery] = useState("");
  const gridRef = useRef<HTMLDivElement>(null);

  const filtered = allProducts?.filter((p) => {
    const matchCat = activeCategory === "全部" || p?.category === activeCategory;
    const matchSearch =
    p?.name?.includes(searchQuery) ||
    p?.nameEn?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    p?.category?.includes(searchQuery);
    return matchCat && matchSearch;
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("revealed");
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px -30px 0px" }
    );
    gridRef?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, [filtered]);

  return (
    <div>
      {/* Filter bar */}
      <div className="sticky top-[72px] z-30 bg-brand-bg/90 backdrop-blur-xl border-b border-white/[0.06] py-4">
        <div className="container-main">
          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
            {/* Category tabs */}
            <div className="flex gap-2 flex-wrap">
              {categories?.map((cat) =>
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-all duration-200 ${
                activeCategory === cat ?
                "bg-primary text-white" : "glass-card text-white/60 hover:text-white hover:border-white/20"}`
                }>
                
                  {cat}
                </button>
              )}
            </div>

            {/* Search */}
            <div className="relative">
              <Icon name="MagnifyingGlassIcon" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
              <input
                type="text"
                placeholder="搜尋產品..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e?.target?.value)}
                className="form-input pl-9 pr-4 py-2 text-sm w-48" />
              
            </div>
          </div>
        </div>
      </div>
      {/* Product count */}
      <div className="container-main pt-8 pb-4">
        <p className="text-sm text-white/40">
          顯示 <span className="text-white font-semibold">{filtered?.length}</span> 件產品
          {activeCategory !== "全部" && <span> · {activeCategory}</span>}
        </p>
      </div>
      {/* Grid */}
      <div ref={gridRef} className="container-main pb-24">
        {filtered?.length === 0 ?
        <div className="text-center py-24">
            <Icon name="ArchiveBoxXMarkIcon" size={48} className="text-white/20 mx-auto mb-4" />
            <p className="text-white/40 font-medium">沒有找到相關產品</p>
            <p className="text-white/25 text-sm mt-1">請嘗試其他搜尋關鍵詞</p>
          </div> :

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
            {filtered?.map((p, i) =>
          <Link
            key={`${p?.id}-${activeCategory}`}
            href={`/product-detail?id=${p?.id}`}
            className={`product-card reveal-hidden`}
            style={{ transitionDelay: `${i % 8 * 0.06}s` }}>
            
                <div className="relative h-56 sm:h-52 overflow-hidden">
                  <AppImage
                src={p?.img}
                alt={p?.alt}
                fill
                className="object-cover product-img" />
              
                  <div className="img-overlay absolute inset-0" />

                  {/* Tags */}
                  <div className="absolute top-3 left-3 flex gap-1.5 flex-wrap max-w-[calc(100%-24px)]">
                    {p?.tags?.slice(0, 2)?.map((tag) =>
                <span key={tag} className="category-badge text-[10px] sm:text-[11px] px-2.5 py-1 rounded-full">
                        {tag}
                      </span>
                )}
                  </div>

                  {/* Stock */}
                  {!p?.inStock &&
              <div className="absolute inset-0 bg-brand-bg/70 flex items-center justify-center">
                      <span className="text-white/60 text-xs font-semibold border border-white/20 px-3 py-1 rounded-full">
                        暫時缺貨
                      </span>
                    </div>
              }
                </div>

                <div className="p-4 sm:p-5">
                  <p className="text-[10px] sm:text-[11px] text-white/35 uppercase tracking-wider mb-1.5">{p?.category}</p>
                  <h3 className="font-serif text-base sm:text-lg text-white font-semibold mb-1 leading-tight">{p?.name}</h3>
                  <p className="text-[11px] sm:text-xs text-white/35 mb-3 sm:mb-4">{p?.nameEn}</p>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-gold-DEFAULT font-bold text-sm sm:text-base">{p?.price}</p>
                      <p className="text-[10px] sm:text-[11px] text-white/30 mt-0.5">{p?.unit}</p>
                    </div>
                    <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Icon name="ArrowRightIcon" size={14} className="text-primary-light" />
                    </div>
                  </div>
                </div>
              </Link>
          )}
          </div>
        }
      </div>
    </div>);

}